module.exports = __webpack_public_path__ + "img/social-group.2f945a86.svg";